// extracted by mini-css-extract-plugin
export default {"wrapper":"BlogPreviewGrid_wrapper__X7w8-","blog":"BlogPreviewGrid_blog__yY64N","logo":"BlogPreviewGrid_logo__M6AD1","icon":"BlogPreviewGrid_icon__Gjfks"};